module.exports = __webpack_public_path__ + "static/onboarding-baad56677e17a1b50df9bf94b756ba9d.mp4";